import { KzIcon } from '../generated-icons/kz-icon.model';
import { kzIconsArrangement } from '../generated-icons/kzIcons-arrangement.icon';
import { kzIconsEnvironment } from '../generated-icons/kzIcons-environment.icon';
import { kzIconsInstallation } from '../generated-icons/kzIcons-installation.icon';
import { kzIconsOthers } from '../generated-icons/kzIcons-others.icon';
import { kzIconsOutdoor } from '../generated-icons/kzIcons-outdoor.icon';
import { kzIconsWork } from '../generated-icons/kzIcons-work.icon';

export const tagCatIcons: KzIcon[] = [
  kzIconsArrangement,
  kzIconsEnvironment,
  kzIconsInstallation,
  kzIconsOthers,
  kzIconsOutdoor,
  kzIconsWork,
];
